import React, { Component } from "react";
import "./rule.scss";
var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
export default class shareRule extends React.Component {

    render() {
        return ( <div className = { isiOS ? 'IOSBulletprivacyHome BulletprivacyHome' : 'BulletprivacyHome' } >
            <div className = "earnestMoney" >
                <h2> 分享解锁行情 </h2>
                <p className = {"shareRulesTitle"}>活动说明</p>
                <p className="shareExplain">分享成功免费查看一天行情。</p>
                < br/>
                <p className = {"shareRulesTitle"}>活动规则</p>
                <p className = {"shareRulesP"}>  
                    1.免费查看条件:用户通过邮宝APP分享页面分享至微信好友、微信群或朋友圈。
                </p>
                <p className = {"shareRulesP"}>  
                    2.免费行情时长:分享成功后获得当天免费查看行情权益，查看时长截止至当日24点。
                </p>
                <p className = {"shareRulesP"}>  
                    3.分享自己商品交易帖至微信群或朋友圈，其他用户可以在微信群和朋友圈直接完成交易，无需返回邮宝APP。
                </p>
                <p className = {"shareRulesP"}> 
                    4.在法律允许范围内，平台有权对活动规则进行调整，本活动为不定期活动，活动终止时间会在活动页面提示或平台其它渠道通知。<br/> 
                </p>
                <p className = {"shareRulesP"}>  
                    5.参与本活动，则视为您已经阅读、理解并同意本活动规则。< br/>
                </p>

            </div> 
            </div>
        );
    }
}